"use strict";

exports.__esModule = true;
exports.ReportNavbar = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = require("styled-components");
var _reactRouterCompat = require("../../../Utils/reactRouterCompat");
var _App = require("../../App");
var _System = require("../../../System");
var _ConfigurableLayout = require("../../ConfigurableLayout");
var _ReportCollection = require("../ReportCollection");
var _dec, _class, _ReportNavbar;
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
/**
 * Navbar for specific reports.
 */
var ReportNavbar = exports.ReportNavbar = (_dec = _ReportCollection.ReportCollectionContext.withContext, _dec(_class = (0, _reactRouterCompat.withRouter)(_class = (0, _styledComponents.withTheme)(_class = (_ReportNavbar = /*#__PURE__*/function (_Component) {
  function ReportNavbar() {
    return _Component.apply(this, arguments) || this;
  }
  _inheritsLoose(ReportNavbar, _Component);
  var _proto = ReportNavbar.prototype;
  _proto.render = function render() {
    var _this$props = this.props,
      title = _this$props.title,
      report = _this$props.report,
      reportCollection = _this$props.reportCollection,
      history = _this$props.history,
      theme = _this$props.theme;
    return /*#__PURE__*/_react["default"].createElement(_App.AppNavbar, {
      "data-testid": "ReportNavbar",
      title: title,
      leftContent: /*#__PURE__*/_react["default"].createElement(_ConfigurableLayout.LayoutSelector, {
        theme: theme,
        large: true,
        minimal: true,
        style: {
          fontSize: theme ? theme.NavbarTitleFontSize : "26px",
          fontWeight: theme ? theme.NavbarTitleFontWeight : 300,
          fontFamily: theme && theme.uiModern ? theme.FontFamilyHeading : undefined
        },
        items: reportCollection.optimisticSearch() || (reportCollection.search(), []),
        selected: [report],
        width: 400,
        onSelect: function onSelect(_ref) {
          var selectedReport = _ref[0];
          if (!selectedReport || selectedReport.id === report.id) {
            return;
          }
          history.push((0, _System.getScreenLocation)("Report", {
            id: selectedReport.id
          }, (0, _System.getLocationQuery)(history.location)));
        }
      })
    });
  };
  return ReportNavbar;
}(_react.Component), _ReportNavbar.defaultProps = {
  reportCollection: undefined,
  history: undefined
}, _ReportNavbar)) || _class) || _class) || _class);